import React from "react";
import { Box, Icon } from "components";
import styled, { useTheme } from "styled-components";

const SquareStyled = styled.div`
  outline: 9999px solid rgba(0, 0, 0, 0.3); //This creates a fullscreen opacity around the square
  position: absolute;
  left: 4%;
  top: 12%;
  height: 45%;
  width: 93%;
  border-radius: 20px;
`;

const getBorderColor = (props) => {
  if (props.isScanUnsuccessful) return props.theme.colors.error;
  if (props.isScanSuccessful) return props.theme.colors.success;
  return props.theme.colors.backgroundQuaternary;
};

const TopRightCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  right: 2.5%;
  top: 11.7%;
  border-top-right-radius: 20px;
  border-top: 4px solid ${getBorderColor};
  border-right: 4px solid ${getBorderColor};
`;

const TopLeftCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  left: 3.3%;
  top: 11.7%;
  border-top-left-radius: 20px;
  border-top: 4px solid ${getBorderColor};
  border-left: 4px solid ${getBorderColor};
`;

const BottomLeftCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  left: 3.3%;
  bottom: 42.7%;
  border-bottom-left-radius: 20px;
  border-bottom: 4px solid ${getBorderColor};
  border-left: 4px solid ${getBorderColor};
`;

const BottomRightCornerStyled = styled.div`
  width: 50px;
  height: 60px;
  position: absolute;
  right: 2.5%;
  bottom: 42.7%;
  border-bottom-right-radius: 20px;
  border-bottom: 4px solid ${getBorderColor};
  border-right: 4px solid ${getBorderColor};
`;

const FixedOverlay = ({
  isScanUnsuccessful,
  isScanSuccessful,
  onClose,
  showCloseButton = true,
}) => {
  const theme = useTheme();
  return (
    <>
      <SquareStyled />
      <TopRightCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      <TopLeftCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      <BottomLeftCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      <BottomRightCornerStyled
        isScanUnsuccessful={isScanUnsuccessful}
        isScanSuccessful={isScanSuccessful}
      />
      {showCloseButton && (
        <Box
          onClick={onClose}
          position="absolute"
          top="30px"
          left="30px"
          style={{ zIndex: theme.zIndex.modalClose }}
        >
          <Icon size="xl" color="backgroundQuaternary" name="Close"></Icon>
        </Box>
      )}
    </>
  );
};

export default FixedOverlay;
